import { Route, Routes as RouterRoutes } from 'react-router';

import { VehicleContainer } from './vehicle_container';
import { VehicleListContainer } from './vehicle_list_container';
import { Routes } from '../../routes';

export const VehiclesContainer = () => (
  <RouterRoutes>
    <Route path={Routes.Vehicle.relativePath} element={<VehicleContainer />} />
    <Route index element={<VehicleListContainer />} />
  </RouterRoutes>
);
